module.exports = __webpack_public_path__ + "img/Einheit_der_Bundespolizei.55b9fcf0.svg";